export const checkPreAccountingFetching = ({ preAccounting: { fetchingData } }) => fetchingData;

export const getPreAccountingData = ({ preAccounting: { data } }) => data;
